<div class="main">
  <ng-container *ngIf="userInfo; else waiting">
    <div class="navbar" style="background-color: #EFEEE7;">
      <app-navbar></app-navbar>
    </div>

    <div class="body">
      <div class="row justify-content-center">

        <div class="col-sm-3">
          <div class="card">
            <img src="../../../../assets/img/fattura_elettronica.png" class="card-img-top">
            <div class="card-body">
              <h5 class="card-title">Fatturazione elettronica</h5>
              <p class="card-text">Il tuo software per gestire in modo semplice e veloce la fatturazione elettronica.</p>
              <button type="button" class="btn btn-light" [disabled]="!fatturazione" (click)="apriFatturazione()">Accedi</button> 
              <button *ngIf="!fatturazione" type="button" class="btn btn-light" style="margin-left: 5px;" (click)="richiediInformazioni('Fatturazione')">Richiedi informazioni</button> 
            </div>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="card">
            <img src="../../../../assets/img/archoptima.png" class="card-img-top">
            <div class="card-body">
              <h5 class="card-title">ArchOptima</h5>
              <p class="card-text">Il tuo servizio di archiviazione documentale</p>
              <button type="button" class="btn btn-light" [disabled]="!archoptima" (click)="apriArchOptima()">Accedi</button> 
              <button *ngIf="!archoptima" type="button" class="btn btn-light" style="margin-left: 5px;" (click)="richiediInformazioni('ArchOptima')">Richiedi informazioni</button> 
            </div>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="card">
            <img src="../../../../assets/img/timbratura.png" class="card-img-top">
            <div class="card-body">
              <h5 class="card-title">Timbratura Virtuale</h5>
              <p class="card-text">Soluzione facile e veloce per tracciare e rendicontare le tue fatture in modo univoco.</p>
              <button type="button" class="btn btn-light" [disabled]="!timbratura">Accedi</button>
              <button *ngIf="!timbratura" type="button" class="btn btn-light" style="margin-left: 5px;" (click)="richiediInformazioni('Timbratura')">Richiedi informazioni</button> 
            </div>
          </div>
        </div>
        

      </div>

      <div class="row justify-content-center">

        <div class="col-sm-3">
          <div class="card">
            <img src="../../../../assets/img/consulenzaiso.png" class="card-img-top">
            <div class="card-body">
              <h5 class="card-title">Consulenza Digitale</h5>
              <p class="card-text">Supportiamo la tua azienda nell'ottenimento e nella gestione delle più comuni certificazioni secondo gli standard ISO.</p>
              <button type="button" class="btn btn-light" [disabled]="!consulenza">Accedi</button> 
              <button *ngIf="!consulenza" type="button" class="btn btn-light" style="margin-left: 5px;" (click)="richiediInformazioni('Consulenza')">Richiedi informazioni</button> 
            </div>
          </div>
        </div>

        <div class="col-sm-3" *ngIf="userInfo.role == '3'">
          <div class="card">
            <img src="../../../../assets/img/conservazione.png" class="card-img-top">
            <div class="card-body">
              <h5 class="card-title">Conservazione a norma</h5>
              <p class="card-text">Conservazione a norma delle fatture e dei documenti informatici</p>
              <button type="button" class="btn btn-light" [disabled]="!conservazione" (click)="apriConservazione()">Accedi</button> 
            </div>
          </div>
        </div>

        <div class="col-sm-3" *ngIf="userInfo.role == '3'">
          <div class="card">
            <img src="../../../../assets/img/amministrazione.png" class="card-img-top">
            <div class="card-body">
              <h5 class="card-title">Amministrazione AR4M</h5>
              <p class="card-text">Pannello amministrativo di AR4M S.r.l.</p>
              <button type="button" class="btn btn-light" (click)="apriAmministrazione()">Accedi</button> 
            </div>
          </div>
        </div>

      </div>
      
    </div>

  </ng-container>
  <ng-template #waiting>
      <app-loading></app-loading>
  </ng-template>
</div>
<router-outlet></router-outlet>

